import { Action, createReducer, on } from '@ngrx/store';
import { Status } from '../../../models/status';
import {
  mileagePlanActivitySearch,
  mileagePlanActivitySearchSuccess,
  mileagePlanActivitySearchFailure,
  initializeMileagePlanActivityServiceState,
  clearActivities,
} from './mileage-plan-activity-service.actions';
import { initialMileagePlanActivityServiceState, mileagePlanActivityLookupAdapter } from './mileage-plan-activity-service.state';

const featureReducer = createReducer(
  initialMileagePlanActivityServiceState,

  on(mileagePlanActivitySearch, (state) => ({
    ...state,
    mileagePlanActivityLookupCRUDStatus: Status.LOADING,
  })),

  on(mileagePlanActivitySearchSuccess, (state, { response }) => {
    return {
      ...state,
      mileagePlanActivityLookupResponse: mileagePlanActivityLookupAdapter.upsertOne(response, state.mileagePlanActivityLookupResponse),
      mileagePlanActivityLookupCRUDStatus: Status.STABLE,
    };
  }),

  on(mileagePlanActivitySearchFailure, (state, { response }) => ({
    ...state,
    mileagePlanActivityLookupResponse: mileagePlanActivityLookupAdapter.upsertOne(response, state.mileagePlanActivityLookupResponse),
    mileagePlanActivityLookupCRUDStatus: Status.STABLE,
  })),

  on(clearActivities, (state) => ({
    ...state,
    mileagePlanActivityLookupResponse: mileagePlanActivityLookupAdapter.getInitialState(),
  })),

  on(initializeMileagePlanActivityServiceState, (state) => ({ ...state, ...initialMileagePlanActivityServiceState }))
);

export function mileagePlanActivityServiceReducer(state = initialMileagePlanActivityServiceState, action: Action) {
  return featureReducer(state, action);
}
